/* eslint-disable import/first */
import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'
import moment from 'moment-timezone'

if (window.currentUserTimezone) { moment.tz.setDefault(window.currentUserTimezone) }

import AlertIndex from 'Components/Alerts/AlertIndex'
import AlertShow from 'Components/Alerts/AlertShow'
import AssignMajorIncident from 'Components/Problems/AssignMajorIncident'
import ClientSLAForm from 'Components/ClientSLA/Form'
import ClientTicketBreakdownForm from 'Components/Reports/Clients/TicketBreakdownForm'
import Dispatcher from 'Components/Dispatcher'
import GenericTimesheetForm from 'Components/Timesheets/GenericTimesheetForm'
import ModuleSelect from 'Components/ModuleSelect'
import MyTicketContainer from 'Components/Tables/Ticket/MyTicketContainer'
import MyTimesheetsContainer from 'Components/Timesheets/MyTimesheets/MyTimesheetsContainer'
import NewProblem from 'Components/Problems/New'
import NoticeForm from 'Components/Notices/NoticeForm'
import NoticesContainer from 'Components/Tables/Notices/NoticesContainer'
import ProblemShow from 'Components/Problems/Show'
import ProblemTable from 'Components/Tables/Problem/ProblemTable'
import RegionSelector from 'Components/RegionSelector/RegionSelector'
import Setting from 'Components/Setting'
import ShowNotice from 'Components/Notices/Show/Notice'
import SurveyForm from 'Components/Surveys/SurveyForm'
import SurveyResponseForm from 'Components/SurveyResponseForm'
import SurveysReport from 'Components/Reports/Surveys'
import TicketCreateForm from 'Components/Tickets/Form'
import TicketCreateModal from 'Components/Tickets/Modal'
import HaloMigrationNotice from 'Components/Tickets/HaloMigrationNotice'
import TicketInvoicingReport from 'Components/Reports/Invoicing/TicketInvoicing'
import TicketsInvoicedReport from 'Components/Reports/Invoicing/TicketsInvoiced'
import TicketsReport from 'Components/Reports/Tickets'
import TicketShow from 'Components/Tickets/TicketShow'
import TicketTable from 'Components/Tables/Ticket/TicketTable'
import TicketTimesheetCreate from 'Components/Tickets/TicketTimesheets/TicketTimesheetCreate'
import TicketTypeForm from 'Components/TicketType/Form'
import TicketTypeShow from 'Components/TicketType/Show'
import TicketTypeTable from 'Components/Tables/TicketType/TicketTypeTable'
import WorkflowForm from 'Components/Workflows/WorkflowForm'
import TicketWorkflowTable from 'Components/Workflows/WorkflowsTable'
import TimesheetsReport from 'Components/Reports/Timesheets'
import TicketTasksReport from 'Components/Reports/TicketTasks'
import TimesheetAdminTable from 'Components/Tables/TimesheetAdminTable/TimesheetAdminTable'
import WorkTypeEditForm from 'Components/WorkType/EditForm'
import TicketQueueForm from 'Components/Tickets/TicketQueues/Form'
import CorrespondenceTemplateForm from 'Components/CorrespondenceTemplate/Form'

const initComponent = (selector, component) => {
  _.each(document.querySelectorAll(selector), (element) => {
    let data = {}
    if (typeof element.dataset.props !== 'undefined') {
      data = JSON.parse(element.dataset.props)
    }
    const reactComponent = React.createElement(component, data)
    ReactDOM.render(reactComponent, element)
  })
}

document.addEventListener('turbolinks:load', () => {
  // define React entry points here
  initComponent('.js-react-AssignMajorIncident', AssignMajorIncident)
  initComponent('.js-react-ClientSLAForm', ClientSLAForm)
  initComponent('.js-react-ClientTicketBreakdownForm', ClientTicketBreakdownForm)
  initComponent('.js-react-Dispatcher', Dispatcher)
  initComponent('.js-react-ModuleSelect', ModuleSelect)
  initComponent('.js-react-MyTicketContainer', MyTicketContainer)
  initComponent('.js-react-MyTimesheetsContainer', MyTimesheetsContainer)
  initComponent('.js-react-NewProblem', NewProblem)
  initComponent('.js-react-NoticeForm', NoticeForm)
  initComponent('.js-react-NoticesTable', NoticesContainer)
  initComponent('.js-react-ProblemShow', ProblemShow)
  initComponent('.js-react-ProblemTable', ProblemTable)
  initComponent('.js-react-ShowNotice', ShowNotice)
  initComponent('.js-react-SurveyForm', SurveyForm)
  initComponent('.js-react-SurveyResponseForm', SurveyResponseForm)
  initComponent('.js-react-SurveysReport', SurveysReport)
  initComponent('.js-react-TicketCreateForm', TicketCreateForm)
  initComponent('.js-react-TicketCreateModal', TicketCreateModal)
  initComponent('.js-react-HaloMigrationNotice', HaloMigrationNotice)
  initComponent('.js-react-TicketInvoicingReport', TicketInvoicingReport)
  initComponent('.js-react-TicketsInvoicedReport', TicketsInvoicedReport)
  initComponent('.js-react-TicketShow', TicketShow)
  initComponent('.js-react-TicketTable', TicketTable)
  initComponent('.js-react-TicketTimesheetCreate', TicketTimesheetCreate)
  initComponent('.js-react-WorkflowForm', WorkflowForm)
  initComponent('.js-react-TicketWorkflowTable', TicketWorkflowTable)
  initComponent('.js-react-TicketsReport', TicketsReport)
  initComponent('.js-react-TicketTypeForm', TicketTypeForm)
  initComponent('.js-react-TicketTypeShow', TicketTypeShow)
  initComponent('.js-react-TicketTypeTable', TicketTypeTable)
  initComponent('.js-react-TimesheetsReport', TimesheetsReport)
  initComponent('.js-react-TimesheetAdminTable', TimesheetAdminTable)
  initComponent('.js-react-RegionSelector', RegionSelector)
  initComponent('.js-react-AlertIndex', AlertIndex)
  initComponent('.js-react-AlertShow', AlertShow)
  initComponent('.js-react-GenericTimesheetForm', GenericTimesheetForm)
  initComponent('.js-react-WorkTypeEditForm', WorkTypeEditForm)
  initComponent('.js-react-TicketQueueForm', TicketQueueForm)
  initComponent('.js-react-Setting', Setting)
  initComponent('.js-react-TicketTasksReport', TicketTasksReport)
  initComponent('.js-react-CorrespondenceTemplateForm', CorrespondenceTemplateForm)
})
